export default __webpack_public_path__ + "static/media/rain.3b464326.gif";